'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
require('../../icons/AccountAdd.js');
require('../../icons/AccountCheck.js');
require('../../icons/AccountRemove.js');
require('../../icons/AccountStar.js');
require('../../icons/Account.js');
require('../../icons/ArrowCollapse.js');
require('../../icons/ArrowDownDrop.js');
require('../../icons/ArrowExpand.js');
require('../../icons/ArrowLeftDrop.js');
require('../../icons/ArrowLeft.js');
require('../../icons/ArrowRightDrop.js');
require('../../icons/Bell.js');
require('../../icons/BullhornOutline.js');
require('../../icons/BurgerMenu.js');
require('../../icons/CalendarDetailed.js');
require('../../icons/CalendarOutline.js');
require('../../icons/CashOff.js');
require('../../icons/Cash.js');
require('../../icons/CautionDecagram.js');
require('../../icons/CautionOutline.js');
require('../../icons/CheckCircled.js');
require('../../icons/CheckDecagram.js');
require('../../icons/CheckOutlinedCircled.js');
require('../../icons/Check.js');
require('../../icons/ChevronDown.js');
require('../../icons/ChevronLeft.js');
require('../../icons/ChevronRight.js');
require('../../icons/ChevronUp.js');
require('../../icons/CircleOutline.js');
require('../../icons/ClipboardTextOutline.js');
require('../../icons/Clock.js');
require('../../icons/CloseCircleFilled.js');
require('../../icons/Close.js');
require('../../icons/CompareArrows.js');
require('../../icons/Corner.js');
require('../../icons/Critical.js');
require('../../icons/Delete.js');
require('../../icons/DocumentEditCircled.js');
require('../../icons/DocumentEditOutline.js');
require('../../icons/DotsVertical.js');
require('../../icons/DownloadFilled.js');
require('../../icons/Draft.js');
require('../../icons/Encryption.js');
require('../../icons/EuroOff.js');
require('../../icons/Euro.js');
var EyeOff = require('../../icons/EyeOff.js');
var Eye = require('../../icons/Eye.js');
require('../../icons/FlagCheckered.js');
require('../../icons/FwSet0Constructionyear1.js');
require('../../icons/FwSet0Constructionyear2.js');
require('../../icons/FwSet0Constructionyear3.js');
require('../../icons/FwSet0Constructionyear4.js');
require('../../icons/FwSet0Corner.js');
require('../../icons/FwSet0Corneretc.js');
require('../../icons/FwSet0CultivableLimited.js');
require('../../icons/FwSet0CultivableNo.js');
require('../../icons/FwSet0CultivableUnsure.js');
require('../../icons/FwSet0Cultivable.js');
require('../../icons/FwSet0ElevatorNo.js');
require('../../icons/FwSet0Elevator.js');
require('../../icons/FwSet0Flat.js');
require('../../icons/FwSet0Garage.js');
require('../../icons/FwSet0House.js');
require('../../icons/FwSet0IndustryDontKnow.js');
require('../../icons/FwSet0IndustryIndustry.js');
require('../../icons/FwSet0IndustryLiveBusiness.js');
require('../../icons/FwSet0IndustryOffice.js');
require('../../icons/FwSet0Industry.js');
require('../../icons/FwSet0KitchenNew.js');
require('../../icons/FwSet0KitchenNo.js');
require('../../icons/FwSet0KitchenOld.js');
require('../../icons/FwSet0LandDevelopmentFull.js');
require('../../icons/FwSet0LandDevelopmentInPart.js');
require('../../icons/FwSet0LandDevelopmentNo.js');
require('../../icons/FwSet0Level1.js');
require('../../icons/FwSet0Level2.js');
require('../../icons/FwSet0Level3.js');
require('../../icons/FwSet0Levelplus.js');
require('../../icons/FwSet0LivingspaceUnknown.js');
require('../../icons/FwSet0Livingspace100.js');
require('../../icons/FwSet0Livingspace200.js');
require('../../icons/FwSet0Livingspace200Plus.js');
require('../../icons/FwSet0ParkingNo.js');
require('../../icons/FwSet0Parking.js');
require('../../icons/FwSet0PlotUnknown.js');
require('../../icons/FwSet0Plot.js');
require('../../icons/FwSet0Plot1000.js');
require('../../icons/FwSet0Plot1000Plus.js');
require('../../icons/FwSet0Plot300.js');
require('../../icons/FwSet0Rooms.js');
require('../../icons/FwSet0SemiDetached.js');
require('../../icons/FwSet0TownhouseCorner.js');
require('../../icons/FwSet0TownhouseMiddle.js');
require('../../icons/GiftCircled.js');
require('../../icons/Hausgold.js');
require('../../icons/HelpOutline.js');
require('../../icons/Help.js');
require('../../icons/HomeOutline.js');
require('../../icons/HouseCircled.js');
require('../../icons/HousePerson.js');
require('../../icons/House.js');
require('../../icons/Industry.js');
require('../../icons/InfoFilled.js');
require('../../icons/InfoOutline.js');
require('../../icons/LabelPercent.js');
require('../../icons/Level2.js');
require('../../icons/LightbulbOn.js');
require('../../icons/LockCircledOutline.js');
require('../../icons/Lock.js');
require('../../icons/Magnifier.js');
require('../../icons/Mail.js');
require('../../icons/Map.js');
require('../../icons/MissingOutline.js');
require('../../icons/OkCircled.js');
require('../../icons/OpenBookOutline.js');
require('../../icons/PageFirst.js');
require('../../icons/PageLast.js');
require('../../icons/Pause.js');
require('../../icons/Pen.js');
require('../../icons/Percent.js');
require('../../icons/PhoneCircled.js');
require('../../icons/Phone.js');
require('../../icons/PiggyBankCircled.js');
require('../../icons/PiggyBank.js');
require('../../icons/Plus.js');
require('../../icons/PremiumStars.js');
require('../../icons/Printer.js');
require('../../icons/RealtyCommercial.js');
require('../../icons/RealtyFlat.js');
require('../../icons/RealtyHouse.js');
require('../../icons/RealtySite.js');
require('../../icons/Rocket.js');
require('../../icons/Rooms.js');
require('../../icons/SpeechBubble.js');
require('../../icons/SpeechBubbles.js');
require('../../icons/Speedometer.js');
require('../../icons/Star.js');
require('../../icons/StatusDontknow.js');
require('../../icons/SwapHorizontalBold.js');
require('../../icons/ThumbDownOutline.js');
require('../../icons/ThumbUpOutline.js');
require('../../icons/TruckFastOutline.js');
require('../../icons/UnorderedList.js');
require('../../icons/User.js');
var Button = require('../Button/Button.js');
require('../Button/StatisticsButton.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/**
 * InputPassword
 *
 * Element that allows users to enter their password.
 */
var InputPassword = react.forwardRef(function (props, ref) {
  var size = props.size,
    colorScheme = props.colorScheme;
  var ownProps = react.omitThemingProps(props);
  var input = react.useFormControl(ownProps);
  var _className = utils.cx('chakra-input-password', props.className);
  var _useState = React.useState(false),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  var handleVisibilityToggle = function handleVisibilityToggle(event) {
    event.preventDefault();
    if (input.disabled) {
      return;
    }
    setIsVisible(!isVisible);
  };
  var buttonStyles = _objectSpread(_objectSpread(_objectSpread({
    h: '100%',
    w: 12,
    opacity: 1,
    transitionProperty: 'common',
    transitionDuration: 'normal',
    _hover: {
      opacity: 0.5
    }
  }, input.disabled && {
    cursor: 'default',
    _hover: {
      opacity: 1
    }
  }), ownProps.isInvalid && {
    outlineStyle: 'solid',
    outlineColor: 'red.400',
    outlineWidth: '1px'
  }), {}, {
    _focusVisible: {
      outlineStyle: 'solid',
      outlineColor: 'blue.400',
      borderRadius: 'sm',
      zIndex: 1
    }
  });
  var addonStyles = {
    backgroundColor: 'white',
    borderColor: 'white',
    boxShadow: 'sm',
    borderLeftRadius: 0,
    borderRightRadius: 'base',
    ml: 0
  };
  var icon = /*#__PURE__*/React__namespace.cloneElement(isVisible ? /*#__PURE__*/React__namespace.createElement(EyeOff.EyeOff, null) : /*#__PURE__*/React__namespace.createElement(Eye.Eye, null), _objectSpread({
    boxSize: '50%',
    color: 'blue.400'
  }, input.disabled && {
    color: 'gray.300'
  }));
  return /*#__PURE__*/React__namespace.createElement(react.InputGroup, {
    variant: "floating",
    size: size,
    colorScheme: colorScheme
  }, /*#__PURE__*/React__namespace.createElement(react.Input, _extends__default["default"]({}, ownProps, input, {
    ref: ref,
    className: _className,
    type: isVisible ? 'text' : 'password',
    autoComplete: "current-password"
  })), /*#__PURE__*/React__namespace.createElement(react.InputRightAddon, {
    sx: addonStyles,
    p: 0
  }, /*#__PURE__*/React__namespace.createElement(Button.Button, {
    variant: "unstyled",
    onClick: handleVisibilityToggle,
    __css: buttonStyles
  }, icon)));
});
InputPassword.displayName = 'InputPassword';
exports.InputPassword = InputPassword;